import { forwardRef, useContext } from 'react'
import { StyledTooltipArrow } from '../styled-components'
import { TooltipContentContextProvider } from './tooltip-context'
import { tooltipArrowAlignmentOptions } from '../constants'
import PropTypes from 'prop-types'

const TooltipArrow = forwardRef((props, forwardedRef) => {
  const { ...arrowProps } = props
  const contentContext = useContext(TooltipContentContextProvider)

  return (
    <StyledTooltipArrow
      {...arrowProps}
      ref={forwardedRef}
      side={contentContext?.side}
      color={contentContext?.color}
    />
  )
})

TooltipArrow.displayName = 'TooltipArrow'

TooltipArrow.propTypes = {
  arrowAlignment: PropTypes.oneOf(Object.values(tooltipArrowAlignmentOptions))
}

export default TooltipArrow
